"use client";

import {useLocale} from "next-intl";
import {usePathname, useRouter} from "@/i18n/navigation";
import {useTransition} from "react";

type Locale = "en" | "hi";

export function LanguageSwitcher() {
  const locale = useLocale() as Locale;
  const pathname = usePathname();
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  const handleSwitch = (nextLocale: Locale) => {
    if (locale === nextLocale) return;

    startTransition(() => {
      router.replace(pathname, {locale: nextLocale});
    });
  };

  return (
    <div
      className="inline-flex min-h-10 items-center gap-1.5 rounded-full border border-[var(--clinic-line)] bg-white/50 px-2.5 py-1 text-sm font-semibold tracking-wide dark:border-white/10 dark:bg-white/5"
      aria-label="Language switcher"
    >
      <button
        type="button"
        onClick={() => handleSwitch("en")}
        className={`rounded-full px-3 py-1.5 transition-colors ${
          locale === "en" ? "bg-[#dcebe6] text-[var(--clinic-brand-text)] dark:bg-teal-900/60 dark:text-teal-200" : "text-[var(--clinic-muted)] hover:text-[var(--clinic-brand-text)]"
        }`}
        disabled={isPending}
        aria-current={locale === "en" ? "true" : undefined}
      >
        EN
      </button>
      <span className="text-[var(--clinic-muted-faint)]" aria-hidden>
        |
      </span>
      <button
        type="button"
        onClick={() => handleSwitch("hi")}
        className={`rounded-full px-3 py-1.5 transition-colors ${
          locale === "hi" ? "bg-[#f5dfd8] text-[var(--clinic-accent-strong)] dark:bg-red-950/50 dark:text-red-200" : "text-[var(--clinic-muted)] hover:text-[var(--clinic-accent-strong)]"
        }`}
        disabled={isPending}
        aria-current={locale === "hi" ? "true" : undefined}
      >
        हिंदी
      </button>
    </div>
  );
}
